module.exports = __webpack_public_path__ + "img/quest_icon_0006_gift.4aaa9aee.png";